// **********************************************************
// Keep selected size when changing unit tabs
// **********************************************************

const radioSelector = 'input[type="radio"][name="product-config-select-size"]';
const checkboxSelector = 'input[type="checkbox"][name="size"]';

document.querySelectorAll('.size-selector').forEach((selector) => {
  selector.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-tab-link]');
    const selected = selector.querySelector(`${radioSelector}:checked`);
    const selectedCheckboxes = [...selector.querySelectorAll(`${checkboxSelector}:checked`)];
    const target = tab && selector.querySelector(`[data-tab-content][id="${tab.dataset.tabId}"]`);
    if (!target || (!selected && selectedCheckboxes.length === 0)) return;

    if (selected) {
      const equivalent = [...target.querySelectorAll(radioSelector)].find((input) => input.value === selected.value);
      if (equivalent) equivalent.checked = true;
    }

    selectedCheckboxes.forEach((source) => {
      const equivalent = [...target.querySelectorAll(checkboxSelector)].find((input) => input.value === source.value);
      if (equivalent && !equivalent.disabled) equivalent.checked = true;
    });
  });
});
